import * as React from 'react';
import { connect } from 'react-redux';
import {fetchSeatMatches} from '../actions/filter-fetch';
import {ISeatMatchResultModel} from '../reducers/fetch-reducer';

interface IFilterResults {
    loadedResults: boolean;
    filterSearchingToast: string;
    numberOfTicketOptions: number;
    requesting: boolean;
}

class FilterResults extends React.PureComponent<IFilterResults, any>{

    render() {
        return (
            <div className="seats-available-toast-container">
                {this.props.loadedResults ?
                    <div className="seats-available-container fade-in">
                        <p className={"seats-available-text"} aria-live="polite">{this.props.numberOfTicketOptions}</p>
                    </div>
                    : null
                }
                {this.props.requesting ?
                    <div className="seats-available-container fade-in">
                        <p className='seats-available-loading-visible'>{this.props.filterSearchingToast}</p>
                    </div>
                    : null
                }
            </div>
        );
    }

}

export default FilterResults;
